module.exports = __webpack_public_path__ + "img/google.e0ede843.png";